<template>
  <div class="container px-4 md:px-0 max-w-6xl mx-auto -mt-32">
    <Header />
    <Hero />
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header";
import Hero from "@/components/Hero";

export default {
  name: "Home",
  components: {
    Header,
    Hero
  },
  methods: {
    track() {
      this.$ga.page("/");
    }
  }
};
</script>
